import { LOCAL_ADD_ON_ID_PREFIX } from '_shared_/UI/AddOns/addOnModel';
import type { NewAddOnRecord } from '_shared_/UI/AddOns/addOnDraft';

/** The piece as the host stored it, without its report on the body it sanitized. */
export const hostRecord = <T extends object>({
    sanitization: _sanitization,
    ...record
}: T & { sanitization?: unknown }) => record;

/** With no host to store a file, the piece shows it from memory until the reader closes. */
export const withLocalImage = <T extends { imageFile?: File | null }>({ imageFile, ...record }: T) =>
    imageFile ? { ...record, imageUrl: URL.createObjectURL(imageFile) } : record;

/** The piece as this reader keeps it with no host, under a local id made of its uuid. */
export const localRecord = ({ uuid, ...record }: NewAddOnRecord) => ({
    ...withLocalImage(record),
    id: `${LOCAL_ADD_ON_ID_PREFIX}${uuid}`,
});
